let close_remote_modal = () => {
    window.Smart.remoteModal.close();
};
export default close_remote_modal;
